import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  commissionPlanTemplate: null,
  commissionPlanTemplates: null,
  commissionPlanTemplateAgents: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const commissionPlanTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.COMMISSIONPLANTEMPLATE_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.COMMISSIONPLANTEMPLATE_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.COMMISSIONPLANTEMPLATE_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default commissionPlanTemplateReducer;
